/*
  Escolha rápida da página inicial.

  Na home a cliente ainda está passeando: mandar ela para a página do produto a
  cada clique custa o passeio. O clique na faixa abre este quadro, ela escolhe o
  tamanho de uma peça ou das duas e adiciona dali mesmo. O botão leva ao
  carrinho exatamente o que tem tamanho marcado: só o top, só a calcinha ou o
  conjunto. Nada vem marcado de fábrica, porque tamanho é decisão dela.

  No catálogo esta lógica não roda: lá a faixa é link normal para a peça, que é
  onde se compra só aquela parte.

  Nada de id fixo no código: os tamanhos vêm do próprio Shopify, pelo .js do
  produto, e a disponibilidade é a que o Shopify entrega. Sem suporte a dialog
  ou com o JavaScript fora do ar, o link continua funcionando sozinho.
*/
(function () {
  'use strict';

  if (typeof window.HTMLDialogElement === 'undefined') return;

  var PARTES = ['top', 'calcinha'];

  /* Textos: Configurações do tema > Peças avulsas no card (layout/theme.liquid
     publica em window.tdsTextosAvulsos). Campo vazio volta ao texto padrão. */
  var TX = window.tdsTextosAvulsos || {};
  function tx(chave, padrao) {
    return typeof TX[chave] === 'string' && TX[chave] !== '' ? TX[chave] : padrao;
  }
  function rotulo(parte) {
    return parte === 'top' ? tx('top', 'Top') : tx('calcinha', 'Calcinha');
  }
  /* [top] e [calcinha] viram o tamanho escolhido */
  function frase(modelo) {
    return modelo
      .replace(/\[top\]/gi, nomeTamanho('top'))
      .replace(/\[calcinha\]/gi, nomeTamanho('calcinha'));
  }
  var cache = {};
  var dialogo = null;
  var campos = {};
  var ocupado = false;
  var indiceFoto = 0;
  var totalFotos = 0;
  var atual = { faixa: null, escolha: { top: null, calcinha: null }, produto: {}, parte: 'top' };

  var moeda = (function () {
    var codigo = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    var formatador;
    try {
      formatador = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: codigo });
    } catch (erro) {
      formatador = null;
    }
    return function (centavos) {
      if (formatador) return formatador.format(centavos / 100);
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    };
  })();

  function pegar(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('produto indisponível');
        return r.json();
      })
      .then(function (dados) {
        cache[url] = dados;
        return dados;
      });
  }

  function icone(parte) {
    var abre =
      '<svg class="tds-avulsos__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"' +
      ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
    if (parte === 'top') {
      return (
        abre +
        '<path d="M4.4 9.5 5.1 6.9M19.6 9.5l-.7-2.6"/>' +
        '<path d="M11 15.3 4.5 9.6C2.3 10.8 1 13.4 1 16c3.4 1.1 7 1.1 10 .6h2c3 .5 6.6.5 10-.6 0-2.6-1.3-5.2-3.5-6.4l-2.3 1.7"/>' +
        '<path d="M16.1 12.3 13 15.3h-2l.2 1.3M13 15.3l-.2 1.3"/>' +
        '</svg>'
      );
    }
    return (
      abre +
      '<path d="M1.9 7.2Q12 9.6 22.1 7.2"/>' +
      '<path d="M1.9 7.2C6 9.2 8.9 13.6 10.2 16.2c.3.6.8.9 1.4.9h.8c.6 0 1.1-.3 1.4-.9C15.1 13.6 18 9.2 22.1 7.2"/>' +
      '<path d="M1.9 7.2C.9 7.6.7 9.3 1.7 9.8M1.6 9.7.8 13.4M2.3 9.6l.8 3.7"/>' +
      '<path d="M22.1 7.2c1 .4 1.2 2.1.2 2.6M22.4 9.7l.8 3.7M21.7 9.6l-.8 3.7"/>' +
      '</svg>'
    );
  }

  function criarDialogo() {
    if (dialogo) return dialogo;

    dialogo = document.createElement('dialog');
    dialogo.className = 'tds-pop';
    dialogo.setAttribute('aria-label', 'Escolha rápida das peças');
    dialogo.dataset.passo = 'foto';
    dialogo.innerHTML =
      '<button type="button" class="tds-pop__x" data-fechar aria-label="Fechar">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" d="M6 6 18 18M18 6 6 18"/></svg>' +
      '</button>' +
      '<div class="tds-pop__grid">' +
      '<div class="tds-pop__galeria" data-galeria>' +
      '<div class="tds-pop__fotos" data-fotos></div>' +
      '<button type="button" class="tds-pop__seta tds-pop__seta--ant" data-ant aria-label="Foto anterior">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" d="M15 4 7 12l8 8"/></svg>' +
      '</button>' +
      '<button type="button" class="tds-pop__seta tds-pop__seta--prox" data-prox aria-label="Próxima foto">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" d="M9 4l8 8-8 8"/></svg>' +
      '</button>' +
      '<span class="tds-pop__conta" data-conta aria-hidden="true"></span>' +
      '<button type="button" class="tds-pop__voltar" data-voltar>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M9 4H4v5M15 4h5v5M15 20h5v-5M9 20H4v-5"/></svg>' +
      '<span>' + escapar(tx('verFoto', 'ver a foto')) + '</span>' +
      '</button>' +
      '</div>' +
      '<div class="tds-pop__lado">' +
      '<p class="tds-pop__eyebrow">' + escapar(tx('eyebrow', 'Escolha rápida')) + '</p>' +
      '<h2 class="tds-pop__titulo" data-titulo></h2>' +
      '<div data-pecas></div>' +
      '<p class="tds-pop__dica" data-dica></p>' +
      '<div class="tds-pop__total" data-total-caixa>' +
      '<span class="tds-pop__total-rot" data-total-rot>' + escapar(tx('totalAmbos', 'As duas peças')) + '</span>' +
      '<span class="tds-pop__total-valor" data-total></span>' +
      '</div>' +
      '<button type="button" class="tds-pop__btn tds-pop__btn--passo" data-escolher>' + escapar(tx('escolher', 'Escolher tamanhos')) + '</button>' +
      '<button type="button" class="tds-pop__btn" data-add>' + escapar(tx('adicionar', 'Adicionar ao carrinho')) + '</button>' +
      '<p class="tds-pop__erro" data-erro role="alert" hidden></p>' +
      '<p class="tds-pop__ou">' +
      '<a data-ir href="#">' + escapar(tx('verConjunto', 'ver o conjunto')) + '</a>' +
      '<span aria-hidden="true">·</span>' +
      '<a data-so-top href="#">' + escapar(tx('verTop', 'ver o top')) + '</a>' +
      '<span aria-hidden="true">·</span>' +
      '<a data-so-calcinha href="#">' + escapar(tx('verCalcinha', 'ver a calcinha')) + '</a>' +
      '</p>' +
      '<p class="visually-hidden" data-status aria-live="polite"></p>' +
      '</div>' +
      '</div>';

    document.body.appendChild(dialogo);

    campos = {
      galeria: dialogo.querySelector('[data-galeria]'),
      fotos: dialogo.querySelector('[data-fotos]'),
      ant: dialogo.querySelector('[data-ant]'),
      prox: dialogo.querySelector('[data-prox]'),
      conta: dialogo.querySelector('[data-conta]'),
      voltar: dialogo.querySelector('[data-voltar]'),
      escolher: dialogo.querySelector('[data-escolher]'),
      titulo: dialogo.querySelector('[data-titulo]'),
      pecas: dialogo.querySelector('[data-pecas]'),
      total: dialogo.querySelector('[data-total]'),
      totalCaixa: dialogo.querySelector('[data-total-caixa]'),
      totalRot: dialogo.querySelector('[data-total-rot]'),
      dica: dialogo.querySelector('[data-dica]'),
      add: dialogo.querySelector('[data-add]'),
      erro: dialogo.querySelector('[data-erro]'),
      status: dialogo.querySelector('[data-status]'),
      ir: dialogo.querySelector('[data-ir]'),
      soTop: dialogo.querySelector('[data-so-top]'),
      soCalcinha: dialogo.querySelector('[data-so-calcinha]')
    };

    campos.add.addEventListener('click', adicionar);

    /*
      Dois passos no celular: primeiro a foto grande, que é o que decide em moda
      praia, e só depois os tamanhos. No computador cabe tudo junto e o CSS
      ignora o passo, então este botão nem aparece lá.
    */
    campos.escolher.addEventListener('click', function () {
      dialogo.dataset.passo = 'escolha';
      var alvo =
        dialogo.querySelector('.tds-pop__tam[aria-pressed="true"]:not([disabled])') ||
        dialogo.querySelector('.tds-pop__tam[data-parte="' + atual.parte + '"]:not([disabled])');
      if (alvo) alvo.focus();
    });

    campos.ant.addEventListener('click', function () { andar(-1); });
    campos.prox.addEventListener('click', function () { andar(1); });

    /*
      Caminho de volta. Com os tamanhos abertos a foto fica pequena, e o
      instinto é tocar nela para ver de novo. O toque na foto funciona, e o
      botão existe porque instinto não é aviso: sozinho, ninguém descobre.
    */
    campos.voltar.addEventListener('click', function () {
      dialogo.dataset.passo = 'foto';
      campos.escolher.focus();
    });

    var partida = null;
    campos.fotos.addEventListener('pointerdown', function (evento) {
      partida = { x: evento.clientX, y: evento.clientY };
    });
    campos.fotos.addEventListener('click', function (evento) {
      if (dialogo.dataset.passo !== 'escolha') return;
      if (evento.target.closest('.tds-pop__seta')) return;
      /* arrastar para trocar de foto não pode contar como toque na foto */
      if (partida) {
        var andou = Math.abs(evento.clientX - partida.x) + Math.abs(evento.clientY - partida.y);
        if (andou > 12) return;
      }
      dialogo.dataset.passo = 'foto';
      campos.escolher.focus();
    });

    var pendente = null;
    campos.fotos.addEventListener('scroll', function () {
      if (pendente) window.clearTimeout(pendente);
      pendente = window.setTimeout(function () {
        var largura = campos.fotos.clientWidth || 1;
        indiceFoto = Math.round(campos.fotos.scrollLeft / largura);
        pintarSetas();
      }, 90);
    });

    dialogo.addEventListener('click', function (evento) {
      if (evento.target.closest('[data-fechar]')) {
        dialogo.close();
        return;
      }
      /* clique no fundo, fora do quadro */
      if (evento.target === dialogo) dialogo.close();

      var pilula = evento.target.closest('.tds-pop__tam');
      if (pilula && !pilula.disabled) escolher(pilula.dataset.parte, Number(pilula.dataset.id));
    });

    dialogo.addEventListener('click', function (evento) {
      var ir = evento.target.closest('[data-ir]');
      if (!ir) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mix_match_select',
        origem: 'escolha_rapida_home',
        destino: ir.getAttribute('href')
      });
    });

    return dialogo;
  }

  function blocoPeca(parte, produto) {
    var unico = produto.variants.length === 1 && produto.variants[0].title === 'Default Title';

    /* Peça de tamanho único também é uma pílula: agora dá para levar uma peça
       sem a outra, então a escolha precisa ser um gesto da cliente. */
    var pilulas =
      '<div class="tds-pop__tams" role="group" aria-label="' +
      escapar(tx('tamanho', 'Tamanho') + ' ' + rotulo(parte)) +
      '">' +
      produto.variants
        .map(function (v) {
          return (
            '<button type="button" class="tds-pop__tam' +
            (unico ? ' tds-pop__tam--unico' : '') +
            '" data-parte="' +
            parte +
            '" data-id="' +
            v.id +
            '" aria-pressed="false"' +
            (v.available ? '' : ' disabled') +
            '>' +
            escapar(unico ? tx('unico', 'Tamanho único') : v.title) +
            (v.available ? '' : '<span class="visually-hidden"> (' + escapar(tx('esgotado', 'esgotado')) + ')</span>') +
            '</button>' +
            ''
          );
        })
        .join('') +
      '</div>';

    return (
      '<div class="tds-pop__peca">' +
      '<div class="tds-pop__cab">' +
      icone(parte) +
      '<span class="tds-pop__nome">' +
      escapar(produto.title) +
      '</span>' +
      '<span class="tds-pop__preco">' +
      moeda(produto.price) +
      '</span>' +
      '</div>' +
      pilulas +
      '</div>'
    );
  }

  function escapar(texto) {
    var div = document.createElement('div');
    div.textContent = texto == null ? '' : String(texto);
    return div.innerHTML;
  }

  function escolher(parte, id) {
    var produto = atual.produto[parte];
    if (!produto) return;
    var variante = produto.variants.filter(function (v) {
      return v.id === id;
    })[0];
    if (!variante || !variante.available) return;

    /* Clicar no tamanho já marcado desmarca: é como se tira uma peça da compra. */
    var mesma = atual.escolha[parte] && atual.escolha[parte].id === id;
    atual.escolha[parte] = mesma ? null : variante;
    dialogo.querySelectorAll('.tds-pop__tam[data-parte="' + parte + '"]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(!mesma && Number(b.dataset.id) === id));
    });
    mostrarErro('');
    atualizar();
  }

  /* nenhum | top | calcinha | ambos */
  function modo() {
    var t = atual.escolha.top;
    var c = atual.escolha.calcinha;
    if (t && c) return 'ambos';
    if (t) return 'top';
    if (c) return 'calcinha';
    return 'nenhum';
  }

  function nomeTamanho(parte) {
    var produto = atual.produto[parte];
    var v = atual.escolha[parte];
    if (!produto || !v) return '';
    var unico = produto.variants.length === 1 && produto.variants[0].title === 'Default Title';
    return unico ? tx('unico', 'Tamanho único') : v.title;
  }

  function atualizar() {
    var estado = modo();
    var algum = estado !== 'nenhum';

    /* Sem escolha o total mostra as duas peças, apagado, como referência.
       Com escolha, mostra só o que vai para o carrinho. */
    var soma = 0;
    PARTES.forEach(function (parte) {
      var v = atual.escolha[parte];
      var produto = atual.produto[parte];
      if (v) soma += v.price;
      else if (!algum && produto) soma += produto.price;
    });
    campos.total.textContent = moeda(soma);
    campos.totalRot.textContent =
      estado === 'top' ? tx('soTop', 'Só o top') : estado === 'calcinha' ? tx('soCalcinha', 'Só a calcinha') : tx('totalAmbos', 'As duas peças');
    campos.totalCaixa.toggleAttribute('data-vazio', !algum);

    /* O botão diz sempre "Adicionar ao carrinho" (decisão do dono, 27/08).
       O que vai junto aparece na linha do total e na dica, não no botão. */
    campos.add.disabled = !algum || ocupado;

    if (estado === 'ambos') {
      campos.dica.textContent = frase(tx('dicaAmbos', 'Top [top] e calcinha [calcinha] vão juntas para o carrinho.'));
    } else if (estado === 'top') {
      campos.dica.textContent = frase(tx('dicaTop', 'Top [top]. Adicione só o top, ou escolha a calcinha também.'));
    } else if (estado === 'calcinha') {
      campos.dica.textContent = frase(tx('dicaCalcinha', 'Calcinha [calcinha]. Adicione só a calcinha, ou escolha o top também.'));
    } else {
      campos.dica.textContent = tx('dicaInicial', 'Escolha o tamanho de uma peça ou das duas.');
    }

    var base = atual.faixa.dataset.conjuntoUrl || '';
    var params = [];
    PARTES.forEach(function (parte) {
      var v = atual.escolha[parte];
      if (!v) return;
      /* a página do conjunto reconhece o tamanho único como "Único" */
      var unico = atual.produto[parte].variants.length === 1 && atual.produto[parte].variants[0].title === 'Default Title';
      params.push(parte + '=' + encodeURIComponent(unico ? 'Único' : v.title));
    });
    campos.ir.setAttribute('href', base + (params.length ? '?' + params.join('&') : ''));
  }

  /* ---------- carrossel de fotos ---------- */

  function comLargura(url, largura) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + largura;
  }

  function montarFotos(urls, alt) {
    totalFotos = urls.length;
    indiceFoto = 0;
    campos.fotos.innerHTML = urls
      .map(function (url, i) {
        return (
          '<figure class="tds-pop__foto">' +
          '<img src="' + comLargura(url, 900) + '" alt="' + (i === 0 ? escapar(alt) : '') + '"' +
          (i === 0 ? '' : ' loading="lazy"') +
          ' width="900" height="1350">' +
          '</figure>'
        );
      })
      .join('');
    campos.fotos.scrollLeft = 0;
    pintarSetas();
  }

  function pintarSetas() {
    var varias = totalFotos > 1;
    campos.galeria.dataset.varias = varias ? 'sim' : 'nao';
    campos.ant.disabled = indiceFoto <= 0;
    campos.prox.disabled = indiceFoto >= totalFotos - 1;
    campos.conta.textContent = varias ? indiceFoto + 1 + '/' + totalFotos : '';
  }

  function andar(passo) {
    var alvo = Math.min(Math.max(indiceFoto + passo, 0), totalFotos - 1);
    if (alvo === indiceFoto) return;
    indiceFoto = alvo;
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    campos.fotos.scrollTo({
      left: alvo * campos.fotos.clientWidth,
      behavior: suave ? 'smooth' : 'auto'
    });
    pintarSetas();
  }

  function mostrarErro(mensagem) {
    if (!campos.erro) return;
    campos.erro.textContent = mensagem || '';
    campos.erro.hidden = !mensagem;
  }

  function erroAmigavel(payload) {
    if (payload) {
      if (typeof payload.description === 'string' && payload.description) return payload.description;
      if (typeof payload.message === 'string' && payload.message && payload.message !== 'Cart Error') {
        return payload.message;
      }
    }
    return tx('erro', 'Não foi possível adicionar agora. Confira a disponibilidade dos tamanhos e tente de novo.');
  }

  /*
    A cliente já escolheu aqui dentro; mandar ela para a página do produto para
    escolher de novo seria trabalho repetido. O botão leva para o carrinho as
    peças que têm tamanho marcado, no mesmo formato do resto da loja (cada peça
    com "Parte escolhida"; quando vão as duas, o mesmo _mix_match_id), e a
    gaveta do carrinho abre por cima da vitrine, sem tirar a cliente de onde
    ela estava.
  */
  function adicionar() {
    var faixa = atual.faixa;
    if (!faixa || ocupado) return;

    var estado = modo();
    if (estado === 'nenhum') {
      mostrarErro(tx('erroNada', 'Escolha o tamanho de pelo menos uma peça.'));
      return;
    }
    var ambos = estado === 'ambos';
    var pecas = PARTES.filter(function (parte) { return Boolean(atual.escolha[parte]); });
    var escolhas = pecas.map(function (parte) { return atual.escolha[parte]; });

    ocupado = true;
    campos.add.setAttribute('aria-busy', 'true');
    campos.add.disabled = true;
    mostrarErro('');
    campos.status.textContent = ambos
      ? 'Adicionando as duas peças ao carrinho.'
      : 'Adicionando ' + (estado === 'top' ? 'o top' : 'a calcinha') + ' ao carrinho.';

    /* O id de combinação só existe quando as duas vão juntas. */
    var conjunto = ambos ? 'tds-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8) : null;
    var itens = pecas.map(function (parte, i) {
      var props = { 'Parte escolhida': rotulo(parte) };
      if (conjunto) props['_mix_match_id'] = conjunto;
      return { id: escolhas[i].id, quantity: 1, properties: props };
    });

    var gaveta = document.querySelector('cart-drawer');
    var corpo = { items: itens };
    if (gaveta && typeof gaveta.getSectionsToRender === 'function') {
      corpo.sections = gaveta.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }

    fetch(faixa.dataset.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(corpo)
    })
      .then(function (resposta) {
        return resposta
          .json()
          .catch(function () { return {}; })
          .then(function (payload) { return { ok: resposta.ok, payload: payload }; });
      })
      .then(function (r) {
        if (!r.ok || r.payload.status === 422) throw new Error(erroAmigavel(r.payload));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mix_match_add_to_cart',
          mix_match_id: conjunto,
          pecas: pecas,
          origem: 'escolha_rapida_vitrine',
          value: escolhas.reduce(function (a, e) { return a + e.price; }, 0) / 100,
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL'
        });

        campos.status.textContent = (ambos ? 'Peças adicionadas' : 'Peça adicionada') + ' ao carrinho.';
        ocupado = false;
        campos.add.removeAttribute('aria-busy');
        dialogo.close();

        if (gaveta && typeof gaveta.renderContents === 'function' && r.payload.sections) {
          /*
            Com o carrinho vazio a gaveta nasce com "is-empty". O renderContents
            tira essa classe do miolo, mas não do elemento, e aí o abrir procura
            o bloco de carrinho vazio que acabou de ser trocado, acha nada e o
            trapFocus quebra. O product-form.js do tema resolve na mesma linha.
          */
          if (gaveta.classList.contains('is-empty')) gaveta.classList.remove('is-empty');
          gaveta.renderContents(r.payload);
        } else {
          window.location.href = faixa.dataset.cartUrl;
        }
      })
      .catch(function (erro) {
        ocupado = false;
        campos.add.removeAttribute('aria-busy');
        mostrarErro(erro && erro.message ? erro.message : erroAmigavel(null));
        campos.status.textContent = 'Não foi possível adicionar ao carrinho.';
        atualizar();
      });
  }

  function abrir(faixa, parteClicada) {
    criarDialogo();

    var lados = {};
    faixa.querySelectorAll('.tds-avulsos__lado').forEach(function (a) {
      lados[a.dataset.peca] = a;
    });

    atual.faixa = faixa;
    atual.escolha = { top: null, calcinha: null };
    atual.produto = {};
    atual.parte = parteClicada;

    dialogo.dataset.passo = 'foto';
    campos.titulo.textContent = faixa.dataset.conjuntoTitulo || '';

    /* A capa entra na hora, com o que o card já sabe. O resto do carrossel
       chega quando o produto responder, sem deixar o quadro vazio no meio. */
    montarFotos([faixa.dataset.conjuntoFoto].filter(Boolean), faixa.dataset.conjuntoTitulo || '');
    if (faixa.dataset.conjuntoJson) {
      pegar(faixa.dataset.conjuntoJson)
        .then(function (conj) {
          if (atual.faixa !== faixa) return;
          var urls = (conj.images || []).slice(0, 6);
          if (urls.length) montarFotos(urls, conj.title || '');
        })
        .catch(function () {});
    }

    campos.pecas.innerHTML = '<p class="tds-pop__carregando">' + escapar(tx('carregando', 'Carregando os tamanhos.')) + '</p>';
    campos.total.textContent = '';
    campos.dica.textContent = tx('dicaInicial', 'Escolha o tamanho de uma peça ou das duas.');
    campos.status.textContent = '';
    campos.add.disabled = true;
    ocupado = false;
    mostrarErro('');
    campos.soTop.setAttribute('href', lados.top ? lados.top.getAttribute('href') : '#');
    campos.soCalcinha.setAttribute('href', lados.calcinha ? lados.calcinha.getAttribute('href') : '#');
    campos.ir.setAttribute('href', faixa.dataset.conjuntoUrl || '#');

    dialogo.showModal();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mix_match_select',
      origem: 'faixa_vitrine',
      parte: parteClicada
    });

    Promise.all(
      PARTES.map(function (parte) {
        return lados[parte] ? pegar(lados[parte].dataset.json) : Promise.resolve(null);
      })
    )
      .then(function (produtos) {
        if (!produtos[0] || !produtos[1]) throw new Error('sem dados das peças');
        atual.produto.top = produtos[0];
        atual.produto.calcinha = produtos[1];

        campos.pecas.innerHTML = PARTES.map(function (parte) {
          return blocoPeca(parte, atual.produto[parte]);
        }).join('');

        /* Nada vem marcado: tamanho errado no carrinho custa uma troca. O
           botão liga na primeira escolha. */

        /* Foco na peça que a cliente clicou, que é a que ela quer resolver. */
        var alvo = dialogo.querySelector('.tds-pop__tam[data-parte="' + parteClicada + '"]:not([disabled])');
        if (alvo) alvo.focus();
        atualizar();
      })
      .catch(function () {
        /* Sem os tamanhos, o quadro não serve: manda para a página do produto. */
        dialogo.close();
        var destino = lados[parteClicada] && lados[parteClicada].getAttribute('href');
        if (destino) window.location.href = destino;
      });
  }

  document.addEventListener('click', function (evento) {
    var lado = evento.target.closest('.tds-avulsos__lado');
    if (!lado) return;
    var faixa = lado.closest('[data-tds-avulsos]');
    if (!faixa || faixa.dataset.modo !== 'popup' || !faixa.dataset.conjuntoUrl) return;
    if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.button !== 0) return;

    evento.preventDefault();
    abrir(faixa, lado.dataset.peca || 'top');
  });
})();
